import { IEvents } from "@walletconnect/jsonrpc-types";
export class IRelayer extends IEvents {
    constructor(client, logger, provider) {
        super();
        this.client = client;
        this.logger = logger;
    }
}
//# sourceMappingURL=relayer.js.map